var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 30",
    width: 34,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 6415-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #9ab93a } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6415",
    className: "s0",
    d: "m1.7 9.5l14.9 6.3q0.1 0.1 0.2 0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2-0.1l14.9-6.3q0.3-0.2 0.5-0.4 0.2-0.3 0.2-0.7 0-0.3-0.2-0.6-0.2-0.2-0.5-0.4l-14.9-6.3q-0.1-0.1-0.2-0.1-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0-0.2 0.1l-14.9 6.3q-0.3 0.2-0.5 0.4-0.2 0.3-0.2 0.6 0 0.4 0.2 0.7 0.2 0.2 0.5 0.4zm29.8 10.7l-14.5 6.1-14.5-6.1c-0.2-0.2-0.6-0.2-0.8-0.1-0.3 0.1-0.5 0.3-0.7 0.6-0.1 0.3-0.1 0.6 0 0.9 0.2 0.3 0.4 0.5 0.7 0.6l14.9 6.3q0.1 0.1 0.2 0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2-0.1l14.9-6.3c0.3-0.1 0.5-0.3 0.7-0.6 0.1-0.3 0.1-0.6 0-0.9-0.2-0.3-0.4-0.5-0.7-0.6-0.2-0.1-0.6-0.1-0.8 0.1zm0-6.4l-14.5 6.2-14.5-6.2c-0.2-0.1-0.5-0.1-0.8 0-0.3 0.1-0.5 0.3-0.6 0.6-0.1 0.2-0.1 0.5 0 0.8 0.1 0.3 0.3 0.5 0.6 0.6l14.9 6.4q0.1 0 0.2 0 0.1 0.1 0.2 0.1 0.1 0 0.2-0.1 0.1 0 0.2 0l14.9-6.4c0.3-0.1 0.5-0.3 0.6-0.6 0.1-0.3 0.1-0.6 0-0.8-0.1-0.3-0.3-0.5-0.6-0.6-0.3-0.1-0.6-0.1-0.8 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/layers_icon.aa7e4aad5fea69c5a6401dc5d308c9ef.svg";
export { ForwardRef as ReactComponent };